import api from '../../services/api';
import * as type from '../types';

export default {
    namespaced: true,
    state: {
        messageHeaders: [
            { text: 'Subject', value: 'subject', sortable: true, width: '200' },
            { text: 'Filename', value: 'attachmentFilename', sortable: true },
            { text: 'Date', value: 'date', sortable: true, width: '200' },
            { text: 'Actions', align: 'center', alignHeader: 'center', width: '260' }
        ],
        messageItems: [],
        messageLoading: false,
        disableFilter: false,
        query: '',
        brands: []
    },
    getters: {
        getMessageHeaders: state => state.messageHeaders,
        getMessageItems: state => state.messageItems,
        getMessageLoading: state => state.messageLoading,
        getDisableFilter: state => state.disableFilter,
        getQuery: state => state.query,
        getBrands: state => state.brands
    },
    mutations: {
        setMessageLoading: (state, payload) => state.messageLoading = payload,
        setDisableFilter: (state, payload) => state.disableFilter = payload,
        setQuery: (state, payload) => state.query = payload.replace('q=',''),
        [type.GMAIL_LOAD_MESSAGES]: (state, payload) => {
            state.messageItems = payload
        },
        [type.EDI_GET_BRANDS]: (state, payload) => {
            state.brands = payload
        }
    },
    actions: {
        [type.EDI_GET_BRANDS]: async ({commit}) => {
            let response = await api.get('/edi/brands');
            commit(type.EDI_GET_BRANDS, response.data)
        },
        [type.GMAIL_LOAD_MESSAGES]: async ({commit}, payload) => {
            commit('setMessageLoading', true)
            commit('setDisableFilter', true)

            let search = payload.search ? `${payload.search} ` : '';
            let sender = payload.sender ? `from:${payload.sender} ` : '';
            let brand = payload.brand ? `has:attachment ${payload.brand} * .html ` : 'filename:html ';
            let after = payload.dateRange.startDate ? `after: ${payload.dateRange.startDate} `: '';
            let before = payload.dateRange.endDate ? `before: ${payload.dateRange.endDate} `: '';
            
            let query = sender || brand ? `q=${sender}${brand}${after}${before}${search}` : '';
            let limit = payload && payload.limit > 0 ? `&limit=${this.payload}` : '';
            commit('setQuery', query);
            try{
                let response = await api.get(`/gmail/messages?${query}${limit}`);
                commit(type.GMAIL_LOAD_MESSAGES, response.data.map(e => {
                    return {...e, isExtracted: false, isLoading: false}
                }))
                return Promise.resolve({query})
            }catch(error){
                console.log(error)
            }finally{
                commit('setMessageLoading', false)
                commit('setDisableFilter', false)
            }
        }
    }
}